import { useEffect } from "react";

type UseKeyboardNavigationPropsT = {
  isEnabled: boolean;
  onEscape: () => void;
  onArrowLeft: () => void;
  onArrowRight: () => void;
};

/**
 * Custom hook for handling keyboard navigation in gallery lightbox
 * Listens for Escape, ArrowLeft, and ArrowRight key presses
 */
export function useKeyboardNavigation({
  isEnabled,
  onEscape,
  onArrowLeft,
  onArrowRight,
}: UseKeyboardNavigationPropsT) {
  useEffect(() => {
    if (!isEnabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      switch (event.key) {
        case "Escape":
          onEscape();
          break;
        case "ArrowLeft":
          onArrowLeft();
          break;
        case "ArrowRight":
          onArrowRight();
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isEnabled, onEscape, onArrowLeft, onArrowRight]);
}
